var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dx-grid',{ref:"grid",attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"onRowClicked":_vm.onRowClicked,"navigationPath":"onRowClicked","navigationField":"onRowClicked","beforeSetupGrid":_vm.beforeSetupGrid,"actions":_vm.actions,"hideHeaderFilter":true,"expandedOptions":{
                enabled: true,
                template: 'account-other-communication',
            }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }